<template>
  <v-dialog v-model="showDialog" max-width="400">
    <v-card class="py-3 px-1">
      <v-card-title>
        <div class="text-h2 font-weight-bold mx-auto">
          Deseja salvar o lead antes de sair?
        </div></v-card-title
      >
      <v-card-actions>
        <div class="mx-auto">
          <v-btn color="primary" text @click="closeAndClean">Fechar </v-btn>
          <v-btn
            color="pink darken-1"
            text
            @click="saveLead"
            :disabled="isCorreios"
            >Salvar lead
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { addLead } from "../../../services/leads";
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },

    closeView: {
      type: Function,
      required: true,
    },
  },

  computed: {
    ...mapState("sales", ["lead", "user", "isCorreios"]),
  },

  methods: {
    ...mapMutations("sales", ["resetOtherState"]),

    saveLead() {
      addLead(this.user);
      this.closeView();
    },

    closeAndClean() {
      this.closeView();
    },
  },
};
</script>
